const stats = [
  { value: "5×", label: "More responses than traditional surveys" },
  { value: "92%", label: "Average completion rate" },
  { value: "<5 min", label: "From signup to first feedback channel" },
  { value: "100%", label: "PII stripped before any human reads it" },
];

export const StatsStrip = () => {
  return (
    <section className="container mx-auto px-3 lg:px-8 pt-10">
      <div className="rounded-3xl bg-white border border-border mkt-shadow-card px-6 sm:px-10 py-8 sm:py-10 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((s) => (
          <div key={s.label} className="text-center lg:text-left">
            <div className="text-4xl lg:text-5xl font-black tracking-tight text-[hsl(var(--mkt-primary))]">
              {s.value}
            </div>
            <div className="mt-2 text-sm text-muted-foreground leading-snug">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
